import {
  baseFilters,
  baseSponsorFilterArray,
  baseStatusFilters,
  MAX_HIT_COUNT
} from '@/lib/constants'
import { TermData } from '@/domain/destinations/constants'
import { SortOrder } from '../search/constants'
import { algoliaCenterSearch } from '@/lib/algoliaCenterSearch'
import { SPONSOR_TIER } from '@/domain/center'
const DEFAULT_BLOG_SEARCH_RADIUS_IN_METERS = 400000
export const DEFAULT_BLOG_PRECISION_IN_METERS = 200000
export const generateNearbyBlogRelatedCenters = async ({
  relatedCenterTermData
}: {
  relatedCenterTermData: TermData
}) => {
  if (!relatedCenterTermData) {
    return []
  }
  const facet = relatedCenterTermData?.type
  const value = relatedCenterTermData?.title

  const termFilter = `${facet}:"${value}"`

  const modifiedBaseSponsorFilterArray = [
    ...baseSponsorFilterArray,
    `sponsor_tier:${SPONSOR_TIER.LOCAL}`
  ].join(' OR ')
  const modifiedBaseSponsorFilter = `(${modifiedBaseSponsorFilterArray})`
  const filters = [
    ...baseStatusFilters,
    modifiedBaseSponsorFilter,
    termFilter
  ].join(' AND ')

  const searchParams = {
    hitsPerPage: MAX_HIT_COUNT,
    aroundLatLngViaIP: true,
    aroundRadius: DEFAULT_BLOG_SEARCH_RADIUS_IN_METERS,
    aroundPrecision: DEFAULT_BLOG_PRECISION_IN_METERS,
    filters,
    sumOrFiltersScore: true,
    ranking: [SortOrder.Custom, SortOrder.Distance]
  }
  try {
    return await algoliaCenterSearch({ query: '', ...searchParams })
  } catch (error) {
    console.error('Error generating nearby related centers:', error)
    return []
  }
}
